<div id="user-profile-header">
  <motif-avatar size="medium" [userName]="fullName" [description]="fullName" />

  <div id="user-profile-data">
    <strong>{{ fullName }}</strong> <br />
    {{ userEmail }}
  </div>
</div>
